import type {
  ApiPaymentMethodBankAccount,
  ApiPaymentMethodCard,
} from 'app/modules/Remote/Organization';

import {cardBrandName} from './cardBrandName';

/** What it takes to name a card or a bank account. */
export type NamedPaymentMethod =
  | Pick<ApiPaymentMethodCard, 'type' | 'brand' | 'last4'>
  | Pick<ApiPaymentMethodBankAccount, 'type' | 'bankName' | 'last4'>;

export function paymentMethodName(method: NamedPaymentMethod): string {
  return method.type === 'card' ? cardBrandName(method.brand) : (method.bankName ?? 'Bank account');
}
